<template>
  <section class="mosaic-grid" id="mosaic-grid">
    <Loading v-if="loading" />
    <Error v-if="error" />
    <GridItem v-for="(child, i) in children" :key="i" :child="child" />
  </section>
</template>

<script>
import { mapActions } from 'vuex';
import Loading from '@/components/Loading';
import Error from '@/components/Error';
import GridItem from '@/components/mosaic/GridItem';

export default {
  name: 'MosaicGrid',
  components: {GridItem, Error, Loading},
  data() {
    return {
      loading: false,
      error: false,
      windowWidth: window.innerWidth,
      gridBreakPointsScale: {
        0: 8,
        480: 8,
        768: 12,
        1024: 18,
      },
    };
  },
  computed: {
    children() {
      const breakpoints = Object.keys(this.gridBreakPointsScale).filter((bp) => this.windowWidth >= bp).pop();
      const numItems = this.gridBreakPointsScale[breakpoints];

      return this.$store.getters['children/all'].slice(0, numItems);
    },
  },
  mounted () {
    this.loadData();
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    ...mapActions('children', [ 'all' ]),
    loadData() {
      this.loading = true;

      const payload = {
        params: {
          posts_per_page: '18', // this should be the max number of children possible in the mosaic
          orderby: 'rand',
        },
      };
      this.all(payload).then().catch((error) => {
        this.error = error;
      }).finally(() => {
        this.loading = false;
      });
    },
    onResize() {
      this.windowWidth = window.innerWidth;
    }
  },
};
</script>

<style></style>
